import { render, staticRenderFns } from "./shipment-bill-share-detail.vue?vue&type=template&id=32015776&scoped=true&"
import script from "./shipment-bill-share-detail.vue?vue&type=script&lang=js&"
export * from "./shipment-bill-share-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32015776",
  null
  
)

export default component.exports